import { useState, useCallback } from 'react';

export type PW9208Mode = 'browse' | 'add' | 'edit';

export function usePW9208Mode() {
  const [mode, setMode] = useState<PW9208Mode>('browse');

  const isEditing = mode === 'add' || mode === 'edit';

  const enterAdd = useCallback(() => setMode('add'), []);
  const enterEdit = useCallback(() => setMode('edit'), []);
  const enterBrowse = useCallback(() => setMode('browse'), []);

  return { mode, setMode, isEditing, enterAdd, enterEdit, enterBrowse };
}
